/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface TTLORouteLocationResponse
 */
export interface TTLORouteLocationResponse {
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof TTLORouteLocationResponse
     */
    station?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof TTLORouteLocationResponse
     */
    location?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof TTLORouteLocationResponse
     */
    country?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof TTLORouteLocationResponse
     */
    region?: GuidIdCodeAndLabel;
}

export function TTLORouteLocationResponseFromJSON(json: any): TTLORouteLocationResponse {
    return TTLORouteLocationResponseFromJSONTyped(json, false);
}

export function TTLORouteLocationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLORouteLocationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'station': !exists(json, 'station') ? undefined : GuidIdCodeAndLabelFromJSON(json['station']),
        'location': !exists(json, 'location') ? undefined : GuidIdCodeAndLabelFromJSON(json['location']),
        'country': !exists(json, 'country') ? undefined : GuidIdCodeAndLabelFromJSON(json['country']),
        'region': !exists(json, 'region') ? undefined : GuidIdCodeAndLabelFromJSON(json['region']),
    };
}

export function TTLORouteLocationResponseToJSON(value?: TTLORouteLocationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'station': GuidIdCodeAndLabelToJSON(value.station),
        'location': GuidIdCodeAndLabelToJSON(value.location),
        'country': GuidIdCodeAndLabelToJSON(value.country),
        'region': GuidIdCodeAndLabelToJSON(value.region),
    };
}


